import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { amountTypeDict, Constants, distributionReasons, fedTaxErrorMap, Frequencies, frequencyDict, positionConstants, RothConversion, toAccountErrorMap, transferTypes } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { Observable, Subject, combineLatest, BehaviorSubject, of } from 'rxjs';
import { InternalTransferActions, TransactionFormActions, PositionsTableActions } from '../../actions';
import { selectInternalTransferInfo, selectInternalTransferServiceError, selectIsFromEdit, selectItIsIdentical ,selectIsRecurring, selectToAccountState, selectIsPositionsCash, selectUseStandingAuth, selectTransferType, selectPtrsInfo, selectITAvailableCashMMF, selectITAvailableCashMargin, selectCostBasisMethod, selectProcessDate, selectIsInputCallFinished, selectItIsRmdEligible, selectTaxWithholdings, selectTranasctionFormProcessDate, selectOpenTwePopupConditions, selectTransactionFormHasError, selectIsInputandPositionsCallFinished, selectITDistributionReason, selectITDistributionReasonMap, selectItTaxPercents, selectIsIraTransaction, selectLoadToAccountError, selectVerifyError, selectToAccountInfo, selectInputIraFields, selectItContributionTypeMap, selectInternalTransferTaxWithholding, selectTransactionFormLoadingState, selectPayIncome, selectFrequency, isRestrictedToAccountEntered } from '../../reducers';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RemoveHyphenFromAccountPipe } from '../../../shared/pipes/remove-hyphen-from-account.pipe';
import { FormatDatePipe } from '../../../shared/pipes/FormatDatePipe';
import { selectClassifications, selectMasterAccount, selectIsIra, selectSubAccountId, selectNraIndicator } from '../../../account-info-header/reducers';
import { ValidateInputService } from '../../../shared/services/validate-input.service';
import { mmddyyyyWithSlashes, toAccountAllowedChars } from '../../../shared/utilities/regex-patterns';
import { InternalTransferInfo } from '../../models/internal-transfer/InternalTransferInfo';
import { isInternalTransferForm, ItExtraPrompts, ItTransactionDetails, TaxWithholdingFields, TransactionForm } from '../../models/form/TransactionForm';
import { IraFields } from '../../models/internal-transfer/IraFields';
import { filter, map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { ComponentState } from '../../../shared/types/ComponentState';
import * as CustomValidators from '../../../shared/utilities/FormValidators';
import { SelectControl, OptionDropdown } from '../../models/OptionDropdownSelect';
import { AmountType } from '../../../shared/types/Transaction';
import { ContributionReason } from '../../models/internal-transfer/ContributionReason';
import { RadioControl } from '../../models/form/FormControlRadio';
import { DateTime } from 'luxon';
import { Classifications } from '../../../account-info-header/models';
import { DistributionReason } from '../../models/internal-transfer/DistributionReason';
import { currencyStringToNumber } from '../../utilities/currencyStringToNumber';
import { RegTypeCode, transactionTypes } from "../../../shared/utilities/Constants";
import * as SelectModels from '../../../shared/controlModels/selectModels';
import { selectStandingAuthTableStartTransactionClickedInternalTransfer } from '../../../shared/reducers';
import { InfoToAccount } from '../../../shared/models/InfoToAccount';
import { FeatureFlagService } from '../../../shared/services/feature-flag-service';

@Component({
  standalone: false,
  selector: 'mm-transaction-details-it',
  templateUrl: './transaction-details-it.component.html',
  styleUrls: ['./transaction-details-it.component.scss'],
  providers: [DatePipe, CurrencyPipe]
})
export class TransactionDetailsItComponent implements OnInit {
  readonly contributionTypeTooltip = Constants.contributionYear;
  @Input() parentForm!: UntypedFormGroup;
  @Input() editFormDetails: TransactionForm | undefined;
  @Input() displayPositionsWarning: boolean;
  @Input() maxLotsWarningMessage: string[];
  @Input() maxLotsWarning: {displayWarning: boolean};
  readonly controlNames = {
    processDate: 'processDate',
    amount: 'amount',
    toAccount: 'toAccount'
  };
  nextBusinessDayCopy: string = Constants.nextBusinessDayCopy
  recipentError: string = Constants.recipentError;
  registrationType: string;
  itInfo: InternalTransferInfo;
  itInfo$: Observable<InfoToAccount>;
  toAccountState$: Observable<ComponentState>;
  distributionReason$: Observable<DistributionReason>;
  distributionReasonMap$: BehaviorSubject<DistributionReason[]> = new BehaviorSubject<DistributionReason[]>([]);
  serverError: boolean;
  serverErrorText: string;
  toAccountError: boolean;
  isToAccountInContext: boolean;
  isRecurringTransaction: boolean;
  isToTrustAccount: boolean = false;
  transferType: string;
  isIdentical:boolean;
  showCostBasisMethod: boolean;
  userInput = { toAccount: '', processDate: '', amount: '' };
  hyphenPipe = new RemoveHyphenFromAccountPipe;
  processDateLabel: string = Constants.processDateLabel;
  secondProcessDateLabel: string = Constants.secondProcessDateLabel;
  endDateLabel: string = Constants.endDateLabel;
  positionProcessDateToolTipMessage: string = positionConstants.PositionProcessDateToolTipMessage;
  subAccountId: string;
  masterAccount: string;
  isFutureYearRmd: boolean;
  currentCostBasis: string = '';
  isOneTimeTotalDist: boolean;
  iraContributionTypeModel: SelectControl = {
    title: 'IRA contribution type',
    controlName: 'iraContributionType',
    options: [],
    validationMessage: 'Contribution type is required'
  };
  toAccountControlNames: {
    trustIncomePercent: 'trustIncomeToPercent',
    trustPrincipalPercent: 'trustPrincipalToPercent',
  };
  toAccountAllowedChars = toAccountAllowedChars;
  formatDatePipe = new FormatDatePipe();
  iraFields: IraFields = new IraFields();
  recurringFrequencyModel: SelectControl = {
    title: 'Set frequency of recurring transfer',
    controlName: 'recurringFrequency',
    options: [],
    validationMessage: `Please select 'Frequency' from dropdown.`
  };
  costBasisMethodModel: RadioControl = {
    title: 'Cost basis method',
    displayIconTooltip: true,
    tooltip: {
      position: 'right',
      containsLink: false,
      content: `When applying a cost basis method, you'll enter a number of shares and Schwab will select lots to transfer per your chosed method. We've preselected this account's default cost basis method for you.`,
    },
    controlName: 'costBasisMethod',
    radios: [
      {
        value: 'FIFO',
        label: ['Account default: FIFO (first-in, first-out)'],
      },
      {
        value: 'LIFO',
        label: ['LIFO (last-in, first-out)'],
      },
      {
        value: 'HCLOT',
        label: ['Highest-cost lot']
      },
      {
        value: 'LCLOT',
        label: ['Lowest-cost lot']
      },
      {
        value: 'None',
        label: [`Select lots manually`]
      }
    ],
    validationMessage: 'Enter a valid Cost Basis Method'
  };
  warningText: string;
  payIncomeModel: SelectControl = SelectModels.payIncomeModel;
  amountTypeSelection: AmountType = amountTypeDict.gross;
  destroy$: Subject<boolean> = new Subject<boolean>();
  useStandingAuth$: Observable<boolean>;
  accountClassifications: Classifications;
  ptrsCallFinished: boolean;
  distributionReasonList: DistributionReason[] | undefined;
  distributionReason: string;
  availableCashMargin: string;
  availableCashMMF: string;
  taxWithholdings: TaxWithholdingFields;
  autoCalculateRmd$: Observable<boolean>;
  processDateValidators: ValidatorFn[] = [Validators.required,
  Validators.pattern(mmddyyyyWithSlashes),
  CustomValidators.notPastDate,
  CustomValidators.notGreaterThanMaxDate(this.maxDate),
  CustomValidators.notAWeekend
  ];
  recurringProcessDateValidators: ValidatorFn[] = [Validators.required,
    Validators.pattern(mmddyyyyWithSlashes),
    CustomValidators.notPastDate,
    CustomValidators.notGreaterThanMaxDate(this.maxDate),
  ];
  secondProcessDateValidators: ValidatorFn[] = [Validators.required,
  Validators.pattern(mmddyyyyWithSlashes),
  CustomValidators.notPastDate
  ];
  endDateValidators: ValidatorFn[] = [
    Validators.pattern(mmddyyyyWithSlashes),
    CustomValidators.notPastDate
  ];
  taxWithholdingFields$: Observable<TaxWithholdingFields>;
  distributionReasonTooltip: string = Constants.itCheckDistributionReasonTooltip;
  downloadRequestFormError: boolean;
  firstParty: boolean;
  defaultWarningIRA: boolean = false;
  isIra: boolean;
  showWarningIRA: boolean = false;
  iraRolloverContributionTypeWarning: string = Constants.iraRolloverContributionTypeWarning;
  @Input() internalTransferTransaction: string;
  isinternalTransfer: boolean;
  frequency: string;
  isNraAccount: boolean;
  positionLotsPhase2EnabledFsg: boolean;
  payIncome$: Observable<string | undefined>;
  frequency$: Observable<"recurring" | "onetime" | "onetimeTotalDist" | undefined> = of("onetime");
  isFirstPartyIraToIraJournal$: Observable<boolean>;
  warningText401kIneligableForEauth: string = Constants.accountTypeIneligibleForEauth;
  hasInternationalFedTaxError: boolean = false;

  constructor(private fb: UntypedFormBuilder, private store: Store, public validationService: ValidateInputService, private readonly changeDetectorRef: ChangeDetectorRef, private featureFlagService: FeatureFlagService) {
    this.store.dispatch(
      InternalTransferActions.transactionDetailsComponentLoaded()
    );
  }

  ngOnInit(): void {
    const itInputForm = this.fb.group({
      toAccount: ['', [Validators.required, Validators.minLength(Constants.toAccountInputLength), Validators.maxLength(Constants.toAccountMaxInputLength)]],
      processDate: [''],
      amount: ['', [Validators.required, CustomValidators.greaterThanZero, CustomValidators.onlyOneDecimal, CustomValidators.isANumber, CustomValidators.only2DecimalPlaces, CustomValidators.lessThan14Digits]]
    });

    this.store.select(selectTransferType).pipe(takeUntil(this.destroy$)).subscribe(type => {
      this.transferType = (typeof type === 'string') ? type : "";
    });

    this.parentForm.setControl('transactionDetails', itInputForm);

    this.toAccountState$ = this.store.select(selectToAccountState);

    this.frequency$ = this.store.select(selectFrequency);
    
    // Update process date status and clear validators when frequency changed as the process date sometimes shows errors when changing frequency
    this.frequency$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.processDate?.markAsUntouched();
      this.processDate?.clearValidators();
    });

    this.distributionReason$ = this.store.select(selectITDistributionReason);

    this.store.select(selectITDistributionReasonMap).pipe(takeUntil(this.destroy$)).subscribe(reasons =>  {
      this.distributionReasonMap$.next(reasons);
    });

    this.store.select(selectFrequency).pipe(takeUntil(this.destroy$)).subscribe(frequency =>  {
      this.isOneTimeTotalDist = frequency === 'onetimeTotalDist'; 
    });
    this.store.select(selectInternalTransferTaxWithholding).pipe(takeUntil(this.destroy$)).subscribe(_taxWithholdings => this.taxWithholdings = _taxWithholdings);

    // Subscribe to transactionForm, when the extra prompts are changed, reset the controls
    this.parentForm.controls.extraPrompts?.valueChanges.pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectStandingAuthTableStartTransactionClickedInternalTransfer)),
      filter(([_extraPrompts, startTransactionClicked]) => !startTransactionClicked)
    ).subscribe(() => {
      this.resetInputFields();
      this.itInputForm.reset();
    });

    this.useStandingAuth$ = this.store.select(selectUseStandingAuth);
    this.store.select(selectClassifications).pipe(takeUntil(this.destroy$)).subscribe(classifications => {
      this.accountClassifications = classifications;
    });

    this.store.select(selectPtrsInfo).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.ptrsCallFinished = info.ptrsCallFinished;
    });

    this.store.select(selectITAvailableCashMMF).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.availableCashMMF = info;
    });

    this.store.select(selectITAvailableCashMargin).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.availableCashMargin = info;
    });

    this.payIncome$ = this.store.select(selectPayIncome);

    //WHEN VERIFY CALL HAS ERROR
    combineLatest([
      this.store.select(selectVerifyError),
      this.store.select(selectTransactionFormLoadingState),
    ])
    .pipe(
      takeUntil(this.destroy$)
    ).subscribe(([error, _loading]) => {
      if (error === Constants.createRequestServiceError) {
        this.downloadRequestFormError = true;
        this.scrollTo('it-download-request-form-error-banner');
      }
      else if (error) {
        this.serverError = true;
        this.serverErrorText = error;
        this.hasInternationalFedTaxError = error.toLowerCase() === fedTaxErrorMap.cashieringInternalTransferInternationalFedTaxError.toLowerCase();
        this.downloadRequestFormError = false;
        this.scrollTo('it-service-error-banner');
      } else {
        this.serverError = false;
        this.serverErrorText = '';
        this.downloadRequestFormError = false;
      }
    })

    // MAP TAX WITHHOLDING FIELDS
    this.taxWithholdingFields$ = this.store.select(selectIsIraTransaction).pipe(
      filter(isIraTransaction => isIraTransaction),
      withLatestFrom(this.store.select(selectItTaxPercents)),
      map(([_isIraTransaction, taxFields]) => taxFields));

    // SET INPUT FORM FOR POSITIONS
    this.store.select(selectIsInputCallFinished).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectIsPositionsCash), this.store.select(selectIsFromEdit))
    ).subscribe(([inputCallFinished, isPositions, isEdit]) => {
      if (isPositions) {
        const today: string = this.currentDate();
        this.itInputForm.controls['processDate']?.setValue(today);
        if (this.transferType === transferTypes.POSITIONS) {
          this.itInputForm.removeControl('amount');
        } else {
          if (isEdit && this.editFormDetails && isInternalTransferForm(this.editFormDetails)) {
            const transactionDetails = this.editFormDetails.transactionDetails;
            this.toAccount?.setValue(transactionDetails.toAccount);
          }
        }
        if (inputCallFinished && !(this.serverError || this.serverErrorText)) {
          this.itInputForm.addControl('costBasisMethod', new UntypedFormControl('', [Validators.required]));
          if (!this.showCostBasisMethod && !isEdit) {
            this.store.dispatch(
              InternalTransferActions.loadPositions()
            );
          }
        }
      }
    })

    // SET COST BASIS
    this.store.select(selectIsInputandPositionsCallFinished).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectCostBasisMethod)),
      filter(([inputAndPositionCallComplete, _method]) => inputAndPositionCallComplete)
    ).subscribe(([_inputAndPositionCallComplete, method]) => {
      if (this.isPositionsTransaction(this.transferType) && method != '') {
        if (this.itInputForm.contains('costBasisMethod')) {
          this.showCostBasisMethod = true;
          this.sortCostBasisRadios(method);
          this.currentCostBasis = method;
        }
      }
       else {
        if(this.isOneTimeTotalDist){
          this.removeCostbaseRadio();
        }
      }
    })

    // SET IT INFO
    this.itInfo$ = this.store.select(selectInternalTransferInfo).pipe(map(val => {
      let info: InfoToAccount = {
        inputCallFinished: val.inputCallFinished,
        toAccountInfo: val.toAccountInfo
      }
      return info;
    }))
    this.store.select(selectInternalTransferInfo).pipe(takeUntil(this.destroy$)).subscribe(itInfo => {
      this.itInfo = itInfo;
      if (itInfo?.inputCallFinished) {
        this.isToAccountInContext = true;
      }
      if (this.isRecurringTransaction) {
        this.setRecurringFrequencyOptions();
      }
    });

    this.store.select(selectIsIra).pipe(takeUntil(this.destroy$)).subscribe(isIraField => {
      this.isIra = isIraField;
    });

    // SET IRA CONTRIBUTION TYPE
    this.store.select(selectItContributionTypeMap).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectIsFromEdit)),
      filter(([_iraContributionTypeMap, isFromEdit]) => !isFromEdit)
    ).subscribe(([iraContributionTypeMap, _isFromEdit]) => {
      if (iraContributionTypeMap.length > 0) {
        this.addIraContributionTypeSelect();
        const filteredContributionReasons = this.filterCurrentYearRolloverForNonIraToIra(iraContributionTypeMap ?? []);
        this.iraContributionTypeModel.options = this.mapContributionReasons(filteredContributionReasons);
      } else {
        this.itInputForm?.removeControl('iraContributionType')
      }
    })

    // SET IRA FIELDS
    this.store.select(selectInputIraFields).pipe(
      takeUntil(this.destroy$)
    ).subscribe(inputIraFields => {
      this.iraFields = inputIraFields;
    })

    this.store.select(selectNraIndicator).pipe(takeUntil(this.destroy$)).subscribe((nraIndicator) => {
          this.isNraAccount = nraIndicator ?? false;
    });  

    // WHEN LOAD TO ACCOUNT HAS ERROR
    combineLatest([
      this.store.select(selectToAccountInfo),
      this.store.select(selectLoadToAccountError)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([toAccountInfo, toAccountError]) => {
      // SET TO ACCOUNT FIELDS
      this.itInputForm?.controls.toAccount.setValue(toAccountInfo.accountNumber);
      this.isToTrustAccount = toAccountInfo.isTrust;
      this.registrationType = toAccountInfo.registrationType;

      if (toAccountError != '') { // In reducer isToAccountFailure have errorText,isToAccountSucess assiging empty string 
        this.downloadRequestFormError = true;
        this.scrollTo('it-download-request-form-error-banner');
      } else {
        this.downloadRequestFormError = false;
      }
    });

    // LOAD REVIEW PAGE
    combineLatest([
      this.store.select(selectOpenTwePopupConditions),
      this.store.select(selectTransactionFormHasError),
    ]).pipe(
      takeUntil(this.destroy$),
    ).subscribe(([popupConditions, formHasError]) => {
      const { verifyCallFinished, openTwePopup } = popupConditions;
      if (verifyCallFinished) {
        this.serverError = false;
        this.serverErrorText = '';
      }

      if (verifyCallFinished && !openTwePopup && !formHasError) {
        this.store.dispatch(TransactionFormActions.loadReviewPage());
      }
    });

    // SET RECURRING FORM FIELDS
    this.store.select(selectIsRecurring).pipe(takeUntil(this.destroy$)).subscribe(isRecurring => {
      this.isRecurringTransaction = isRecurring;
      if (isRecurring) {
        this.itInputForm.addControl('recurringFieldsFormGroup', this.fb.group({
          recurringFrequency: new UntypedFormControl('', [Validators.required])
        }));
      } else if (this.itInputForm && this.itInputForm.contains('recurringFieldsFormGroup')) {
        this.itInputForm?.removeControl('recurringFieldsFormGroup');
      }
    });

    this.store.select(selectIsInputCallFinished).pipe(takeUntil(this.destroy$)).subscribe(inputCallFinished => {
      if (inputCallFinished && this.taxWithholdings) {
        this.taxWithholdings.distributionReason = '';
      }
    });

    // SET PROCESS DATE
    this.store.select(selectProcessDate).pipe(takeUntil(this.destroy$)).subscribe(processDate => {
      if (this.isPositionsTransaction(this.transferType)) {
        this.itInputForm.addControl('processDate', new FormControl(''));
        this.processDate?.setValue(this.formatDatePipe.transform(this.currentDate()));
      }
      else {
        this.processDate?.setValue(this.formatDatePipe.transform(processDate));
      }
    });

    // SERVICE ERROR
    this.store.select(selectInternalTransferServiceError).pipe(takeUntil(this.destroy$)).subscribe(serviceErrorText => {
      let slashIdx = serviceErrorText.lastIndexOf('/');
      let colonIdx = serviceErrorText.lastIndexOf(':');

      // don't show service error for failed verify or input calls - error shown in transaction form
      if (serviceErrorText && !(serviceErrorText.substring(slashIdx + 1, colonIdx) === 'JournalVerify') &&
        !(serviceErrorText.substring(slashIdx + 1, colonIdx) === 'JournalInput')) {
        this.serverError = true;
        this.serverErrorText = serviceErrorText;
      }
    });

    // SET SUBACCOUNT
    this.store.select(selectSubAccountId).pipe(takeUntil(this.destroy$)).subscribe(sub => {
      this.subAccountId = sub;
    });

    // SET MASTER ACCOUNT
    this.store.select(selectMasterAccount).pipe(takeUntil(this.destroy$)).subscribe(masterAccount => {
      this.masterAccount = masterAccount;
    });

    this.isFirstPartyIraToIraJournal$ = combineLatest([
      this.store.select(selectItIsIdentical),
      this.store.select(selectIsIraTransaction),
      this.itInfo$
    ]).pipe(
      map(([isFirstParty, isIra, itInfo]) => {
        return isFirstParty && isIra && itInfo?.toAccountInfo?.isIraAccount;
      })
    );

    // MAP BOOLEAN OBSERVABLE FOR RECURRING RMD
    this.autoCalculateRmd$ = combineLatest([
      this.store.select(selectIsRecurring),
      this.store.select(selectItIsRmdEligible),
      this.store.select(selectITDistributionReason),
      this.store.select(selectTranasctionFormProcessDate),
    ]).pipe(map(([isRecurring, isRmdEligible, distributionReason, processDate]) => isRecurring && isRmdEligible && distributionReason?.description === distributionReasons.rmd && this.isProcessDateInFutureYear(processDate!)));

    // MAP LOCAL BOOLEAN FOR RECURRING RMD
    this.autoCalculateRmd$.pipe(takeUntil(this.destroy$)).subscribe(isFutureYearRmd => {
      this.isFutureYearRmd = isFutureYearRmd;
    });

    this.parentForm.controls?.transactionDetails?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if(value){
        if(this.isRecurringTransaction){
          this.parentForm.controls?.transactionDetails?.get('taxWithholdingsFormGroup')?.get('distributionReason')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
            if (value) {
              if(this.recurringRMDDateError){
                this.processDate?.setValidators(CustomValidators.futureRMDYear);
                this.processDate?.updateValueAndValidity();
              }
              else{
                this.processDate?.removeValidators(CustomValidators.futureRMDYear);
                this.processDate?.updateValueAndValidity();
              }
            }
          })
        }
      }
    })

    // EDIT FLOW
    this.store.select(selectIsFromEdit).pipe(takeUntil(this.destroy$)).subscribe(isFromEdit => {
      if (isFromEdit && this.editFormDetails && isInternalTransferForm(this.editFormDetails)) {
        // If in edit flow, set the values of the controls to the values from the editForm and also set the UI elements like account registration details
        const transactionDetails = this.editFormDetails.transactionDetails;
        this.processDate?.setValue(this.formatDatePipe.transform(this.itInfo.processDate));
        this.amount?.setValue(transactionDetails.amount);
        this.toAccount?.setValue(transactionDetails.toAccount);
        this.distributionReasonList = this.itInfo.inputIraFields.distributionReasonMap;
        this.isToTrustAccount = this.itInfo.toAccountInfo.isTrust;

        const extraPrompts = this.editFormDetails.extraPrompts;
        const frequency = this.getFrequency(extraPrompts);
        if (this.isPositionsTransaction(this.editFormDetails.extraPrompts.transferType)) {
          this.store.select(selectCostBasisMethod).pipe(takeUntil(this.destroy$)).subscribe(defaultCostBasisMethod => {
            var itExtraPrompts = this.editFormDetails?.extraPrompts as ItExtraPrompts;
            if  (!(itExtraPrompts?.frequency === "onetimeTotalDist" && (this.editFormDetails?.transactionDetails?.costBasisMethod === undefined))) {
            this.itInputForm.addControl('costBasisMethod', new UntypedFormControl('', [Validators.required]));
            }
            if (defaultCostBasisMethod) {
              this.sortCostBasisRadios(defaultCostBasisMethod);
            }
            this.currentCostBasis = this.editFormDetails?.transactionDetails.costBasisMethod !== undefined && !this.currentCostBasis ? this.editFormDetails.transactionDetails.costBasisMethod : this.currentCostBasis;
            this.costBasisControl?.patchValue(this.currentCostBasis);
            var editCostBasis = this.editFormDetails?.transactionDetails.costBasisMethod !== undefined && this.editFormDetails?.transactionDetails.costBasisMethod !== '' ? this.editFormDetails?.transactionDetails.costBasisMethod : this.currentCostBasis;
            this.costBasisControl.setValue(editCostBasis);           
             if(itExtraPrompts.frequency === "onetimeTotalDist" && (this.editFormDetails?.transactionDetails.costBasisMethod === undefined || this.editFormDetails?.transactionDetails.costBasisMethod === '')){
              this.showCostBasisMethod = false;
            }else {
              this.showCostBasisMethod = true;
            }
            if (this.transferType === transferTypes.POSITIONS) {
              this.itInputForm.removeControl('amount');
            }
          });
          this.store.dispatch(PositionsTableActions.loadEdit());
        }

        if (transactionDetails.toAccounts !== undefined) {
          if (this.toAccount?.value.length > 0 && this.toAccount?.value !== undefined) {
            this.resetInputFields();
            this.toAccount?.reset();
          }
        }

        if (frequency === Frequencies.recurring) {
          this.setRecurringFrequencyOptions();
          this.itInputForm.setControl('recurringFieldsFormGroup', this.fb.group({
            recurringFrequency: new UntypedFormControl(transactionDetails.recurringFieldsFormGroup.recurringFrequency, [Validators.required]),
            endDate: new UntypedFormControl(transactionDetails.recurringFieldsFormGroup.endDate, [CustomValidators.notPastDate])
          }));
          if (this.recurringFrequency?.value === 'SEMIMTH') {
            this.recurringFieldsFormGroup.addControl('secondProcessDate', new UntypedFormControl(transactionDetails.recurringFieldsFormGroup.secondProcessDate, this.secondProcessDateValidators));
          } else if (this.recurringFrequency?.value === 'LASTBIZ') {
            this.recurringFieldsFormGroup.addControl('payIncome', new UntypedFormControl(transactionDetails.recurringFieldsFormGroup.payIncome));
          }
        }

        if (this.accountClassifications.isPtrs) {
          this.transactionDetailsFormGroup.addControl(
            'trustIncomePercent',
            this.fb.control(transactionDetails.trustIncomePercent, [
              Validators.required,
              CustomValidators.zeroOrGreater,
              CustomValidators.lessThanOrEqualTo100,
            ])
          );

          this.transactionDetailsFormGroup.addControl(
            'trustPrincipalPercent',
            this.fb.control(transactionDetails.trustPrincipalPercent, [
              Validators.required,
              CustomValidators.zeroOrGreater,
              CustomValidators.lessThanOrEqualTo100,
            ])
          );

          this.transactionDetailsFormGroup.addControl(
            'trustTaxCategory',
            this.fb.control(transactionDetails.trustTaxCategory, [
              Validators.required
            ])
          );

          this.transactionDetailsFormGroup.addControl(
            'trustTaxCode',
            this.fb.control(transactionDetails.trustTaxCode, [
              Validators.required
            ])
          );

          this.transactionDetailsFormGroup.addControl(
            'trustPaidFor',
            this.fb.control(transactionDetails.trustPaidFor, [
              Validators.required
            ])
          );
        }

        if (this.itInfo.toAccountInfo.isTrust) {
          this.transactionDetailsFormGroup.addControl(
            'trustIncomeToPercent',
            this.fb.control(transactionDetails.trustIncomeToPercent)
          );

          this.transactionDetailsFormGroup.addControl(
            'trustPrincipalToPercent',
            this.fb.control(transactionDetails.trustPrincipalToPercent)
          );

          this.transactionDetailsFormGroup.addControl(
            'trustDepositCode',
            this.fb.control(transactionDetails.trustDepositCode)
          );
        }

        if (this.accountClassifications.isPtrs || this.itInfo.toAccountInfo.isTrust) {
          this.transactionDetailsFormGroup.addControl(
            'trustComment',
            this.fb.control(transactionDetails.trustComment)
          );
        }

        if (this.itInfo.inputIraFields.isIraTransaction) {
          this.taxWithholdings = {
            fedTaxPercent: this.itInfo.inputIraFields.fedTaxPercent,
            fedTaxAmount: this.itInfo.inputIraFields.fedTaxAmount,
            stateTaxPercent: this.itInfo.inputIraFields.stateTaxPercent,
            stateTaxAmount: this.itInfo.inputIraFields.stateTaxAmount,
            distributionReason: this.itInfo.inputIraFields.distributionReason.description,
            distributionReasonMap: this.itInfo.inputIraFields.distributionReasonMap
          }
        }

        if (this.itInfo.iraContributionTypeMap.length > 0) {
          const filteredContributionReasons = this.filterCurrentYearRolloverForNonIraToIra(this.itInfo.iraContributionTypeMap);
          this.iraContributionTypeModel.options = this.mapContributionReasons(filteredContributionReasons);
          this.addIraContributionTypeSelect(this.editFormDetails.transactionDetails.iraContributionType);
        }
        this.isToAccountInContext = true;
        this.iraFields = this.itInfo.inputIraFields;
        this.amountTypeSelection = this.editFormDetails.transactionDetails.amountType;
        if (!this.itInfo.iraFields.isIraTransaction) {
          this.store.dispatch(TransactionFormActions.editLoadComplete());
        }
      }
    });
  }

  get transactionDetailsFormGroup() {
    return this.parentForm.controls.transactionDetails as UntypedFormGroup
  }

  removeCostbaseRadio() {
    this.showCostBasisMethod = false;
    if (this.itInputForm?.contains('costBasisMethod')) {
      this.itInputForm?.removeControl('costBasisMethod');
    }
  }

  currentDate() {
    return DateTime.now().setZone('America/New_York').toFormat('MM/dd/yyyy');
  }

  sortCostBasisRadios(method: string) {
    if (method === "BTAX") {
      this.costBasisMethodModel.radios = [
        {
          value: 'BTAX',
          label: ['Account default: Tax Lot Optimizer'],
          warning: {
            text: positionConstants.taxLotOptimizerInputWarningMessage,
            displayBelow: true
          }
        },
        {
          value: 'FIFO',
          label: ['FIFO (first-in, first-out)'],
        },
        {
          value: 'LIFO',
          label: ['LIFO (last-in, first-out)'],
        },
        {
          value: 'LCLOT',
          label: ['Lowest-cost lot']
        },
        {
          value: 'None',
          label: [`Select lots manually`]
        }
      ];
      this.costBasisControl?.patchValue(this.costBasisMethodModel.radios[0].value);
    }
    else if (method !== null && method !== '') {
      let costBasisLabel = ['FIFO (first-in, first-out)', 'LIFO (last-in, first-out)', 'Highest-cost lot', 'Lowest-cost lot',];
      let costBasisValue = ['FIFO', 'LIFO', 'HCLOT', 'LCLOT',];
      let costBasisStack = [];
      let index = 1;
      this.costBasisMethodModel.radios[0].value = method;
      costBasisStack.push(method);
      for (var i = 0; i < costBasisLabel.length; i++) {
        if (costBasisStack.includes(costBasisValue[i]) && method == costBasisValue[i]) {
          this.costBasisMethodModel.radios[0].label = ["Account default: " + costBasisLabel[i]];
          this.costBasisControl?.patchValue(this.costBasisMethodModel.radios[0].value);
        }
        if (!costBasisStack.includes(costBasisValue[i])) {
          this.costBasisMethodModel.radios[index].label = [costBasisLabel[i]];
          this.costBasisMethodModel.radios[index].value = costBasisValue[i];
          index++;
        }
        costBasisStack.push(costBasisValue[i]);
      }
    }
  }

  mapContributionReasons(iraContributionTypeMap: ContributionReason[]): OptionDropdown[] {
    return iraContributionTypeMap.filter(elem => {
      return this.isPositionsTransaction(this.transferType) && !!this.itInfo.positionsValidIraContributionCode ? elem.code === this.itInfo.positionsValidIraContributionCode && elem.description !== 'Select One' : elem.description !== 'Select One'
    }).map(element => new OptionDropdown(element.description, element.description));
  }

  filterCurrentYearRolloverForNonIraToIra(contributionReasons: ContributionReason[]): ContributionReason[] {
    if (!this.isNonIraToIraJournal()) {
      return contributionReasons;
    }

    const currentYear = DateTime.now().year.toString();

    return contributionReasons.filter(reason => {
      const description = reason.description?.toUpperCase() ?? '';
      const isRollover = description?.includes(Constants.iraRolloverLabel);
      if (!isRollover) {
        return true;
      }
      return reason.year === currentYear;
    });
  }

  isNonIraToIraJournal(): boolean {
    return this.accountClassifications?.isIra === false && !!this.itInfo?.toAccountInfo?.isIraAccount;
  }

  addIraContributionTypeSelect(contributionReason: string = '') {
    this.itInputForm.addControl('iraContributionType', new UntypedFormControl(contributionReason, [Validators.required]));

    this.itInputForm?.controls.iraContributionType.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (value) {
        this.serverError = false;
        this.serverErrorText = '';
      }
    })
  }

  onProcessDateChange(date: string) {
    this.processDate?.setValue(date);
  }

  onEndDateChange(date: string) {
    this.endDate?.setValue(date);
  }

  onSecondProcessDateChange(date: string) {
    this.secondProcessDate?.setValue(date);
  }

  onChange(event: any) {
    this.showWarningIRA = event.target.value.includes(Constants.iraRolloverLabel) ? true : false;
    this.defaultWarningIRA = false;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  resetInputFields(): void {
    this.amount?.reset();
    this.processDate?.reset();
    this.itInputForm.get('recurringFieldsFormGroup')?.reset();
    this.itInputForm.removeControl('iraContributionType');
    this.isToAccountInContext = false;
    this.serverError = false;
    this.serverErrorText = '';
    this.iraFields = new IraFields();
    this.store.dispatch(InternalTransferActions.clearToAccount());
    this.removeCostbaseRadio();
  }

  resetForm() {
    this.resetInputFields();
    this.showWarningIRA = false;
  }

  isRothConversionRequest() {
    return this.itInfo.inputIraFields.distributionReasonMap.some(
      d =>
        (d.code.trim() === RothConversion.DistributionReasons.OVER_59_AND_A_HALF_CONVERSION_CODE ||
          d.code.trim() === RothConversion.DistributionReasons.UNDER_59_AND_A_HALF_CONVERSION_CODE) &&
        d.subCode === RothConversion.DistributionReasons.CONVERSION_SUB_CODE
    );
  }

  isPositionsTransaction(transferType?: string): boolean {
    return transferType === transferTypes.POSITIONS || transferType === transferTypes.POSITIONS_CASH;
  }

  is401k(): boolean {
    return this.itInfo.toAccountInfo.regTypeShortName === 'I401(k)' || this.itInfo.toAccountInfo.regTypeShortName === 'Roth I401(k)';
  }

  scrollTo(elemName: string){
    setTimeout(() => {
      const bannerEl = document.getElementById(elemName);
      bannerEl?.focus();
      bannerEl?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }, 100)
  }

  get recurringRMDDateError(): boolean{
    if(this.itInputForm?.controls?.taxWithholdingsFormGroup?.get('distributionReason')?.value === distributionReasons.rmd){
      return true;
    }
    return false;
  }

  get isPositions(): boolean {
    return this.transferType === transferTypes.POSITIONS;
  }

  get toAccount() {
    return this.itInputForm.get('toAccount');
  }

  get processDate() {
    return this.itInputForm?.get('processDate');
  }

  get isFromPtrsAccount() {
    return this.accountClassifications.isPtrs ? true : false;
  }

  get amount() {
    return this.itInputForm?.get('amount');
  }

  get amountType() {
    return this.itInputForm.get('amountType')
  }

  get disableDateSelect() {
    return (this.accountClassifications.isIra && this.isRothConversionRequest()) || this.isPositionsTransaction(this.transferType);
  }

  get recurringFrequency() {
    return this.recurringFieldsFormGroup?.get('recurringFrequency');
  }

  get endDate() {
    return this.recurringFieldsFormGroup?.get('endDate');
  }

  get secondProcessDate() {
    return this.recurringFieldsFormGroup?.get('secondProcessDate');
  }

  get payIncome() {
    return this.recurringFieldsFormGroup?.get('payIncome');
  }

  get itInputForm(): UntypedFormGroup {
    return this.parentForm.controls?.transactionDetails as UntypedFormGroup;
  }

  get taxWithholdingsFormGroupDetails() {
    return (this.editFormDetails?.transactionDetails as ItTransactionDetails)?.taxWithholdingsFormGroup;
  }

  get recurringFieldsFormGroup(): UntypedFormGroup {
    return this.itInputForm.controls?.recurringFieldsFormGroup as UntypedFormGroup;
  }

  get extraPrompts(): UntypedFormGroup {
    return this.parentForm.controls.extraPrompts as UntypedFormGroup;
  }

  get showTrustFields(): boolean {
    if (this.isRecurringTransaction || !this.isToAccountInContext || (!this.itInfo.inputCallFinished && !this.editFormDetails)) {
      return false;
    }

    if (this.ptrsCallFinished || (this.isToTrustAccount && !this.isFromPtrsAccount && this.isToAccountInContext && !this.itInfo.isTrustNonPTRSAccount)) {
      return true;
    }
    return false;
  }

  get toAccountValidationError() {
    if (this.toAccount && this.toAccount.errors) {
      const errorKeys: string[] = Object.keys(this.toAccount.errors ?? {});
      if (errorKeys.length > 0) {
        return toAccountErrorMap[errorKeys[0] as keyof typeof toAccountErrorMap];
      }
    }
  }

  get isToAccountEmpty(): boolean {
    if (this.itInputForm?.controls.toAccount.value ===  "") {
      this.isToAccountInContext = false;
      this.downloadRequestFormError = false;
      return true;
    }
    else return false;
  }

  get availableCash(): number {
    return currencyStringToNumber(this.availableCashMargin) + currencyStringToNumber(this.availableCashMMF);
  }

  get costBasisControl(): UntypedFormControl {
    return this.itInputForm?.get('costBasisMethod') as UntypedFormControl;
  }

  get overdraftRulesFutureDate(): Date {
    let today = new Date(new Date().setHours(0, 0, 0, 0));
    return new Date(today.setDate(today.getDate() + 1));
  }

  get futureDate(): boolean {
    if (this.processDate !== null) {
      var selectedDate = new Date(this.processDate!.value);
      return selectedDate.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0);
    }
    return false;
  }

  get showServerError() {
    const isI401kToAccount = this.registrationType === RegTypeCode.ROTH_401K || this.registrationType === RegTypeCode.INDIVIDUAL_401K;
    const isCustodialToAccount = this.registrationType === RegTypeCode.CUSTODIAL;
    return (
      (this.serverError && !this.isInvalidDigitalToPdfToAccount()) ||
      (this.serverError && (isI401kToAccount || isCustodialToAccount) && this.serverErrorText !== this.recipentError)
    );
  }

  isInvalidDigitalToPdfToAccount(): boolean {    
    return (this.registrationType == RegTypeCode.INDIVIDUAL_401K || this.registrationType == RegTypeCode.CUSTODIAL || this.registrationType == RegTypeCode.ROTH_401K)
  }
  
  isProcessDateInFutureYear(date: string): boolean {
    if (date) {
      let curYear = new Date().getFullYear();
      let yearSelected = new Date(date).getFullYear();
      return yearSelected > curYear;
    }
    return false;
  }

  setRecurringFrequencyOptions(): void {
    this.recurringFrequencyModel.options =
      this.itInfo.recurringFields.frequencyList
        .filter(
          (frequency) =>
            frequency.description !== 'Select One' &&
            frequency.code !== 'ACCRUED'
        )
        .map(
          (frequency) =>
            new OptionDropdown(frequency.code, frequency.description)
        );
  }


  get minDate(): Date {
    return new Date();
  }

  get maxDate(): Date {
    let maxDate: Date = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 2);
    return maxDate;
  }

  get displayTaxWithholdingsFields() {
    return this.iraFields.isIraTransaction && (this.itInfo.inputCallFinished || this.editFormDetails);
  }

  defaultIRAWarning(event: boolean) {
    this.defaultWarningIRA = event;
  }

  isInternalTransfer(): boolean {
    return this.internalTransferTransaction === transactionTypes.internalTransfer ? true : false;
  }

  // Sets the frequency as onetime or recurring for edit bundle flow
  getFrequency(extraPrompts: ItExtraPrompts) {
    if (extraPrompts.useStandingAuth === 'bundled') {
      if (extraPrompts.useBundledStandingAuth === 'no') {
        return Frequencies.onetime;
      }
      else {
        if (extraPrompts.useBundledStandingAuth === 'recurring' || (extraPrompts.useBundledStandingAuth === 'yes' && extraPrompts.frequency === 'recurring')) {
          return Frequencies.recurring;
        }
        else {
          return '';
        }
      }
    }
    else {
      return extraPrompts.frequency;
    }
  }
}
